import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { UserRole, RoleRoutes } from '@/types/global.types';

interface RequireFinanceProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that checks if the finance solution is enabled for the tenant.
 * If not enabled, redirects to the user's dashboard.
 * SUPER_ADMIN always has access for administration purposes.
 */
export const RequireFinance: React.FC<RequireFinanceProps> = ({ children }) => {
  const user = useAuthStore((state) => state.user);

  // SUPER_ADMIN can always access finance routes (for administration purposes)
  if (user?.role === UserRole.SUPER_ADMIN) {
    return <>{children}</>;
  }

  // Check if finance solution is enabled
  const isFinanceEnabled = user?.enabledSolutions?.includes('finance') ?? false;

  if (!isFinanceEnabled) {
    // Redirect to dashboard if finance is not enabled
    const roleRoute = user?.role ? RoleRoutes[user.role] : null;
    const dashboardPath = user?.tenantId && roleRoute
      ? roleRoute.replace(':tenantId', user.tenantId) + '/dashboard'
      : '/';
    return <Navigate to={dashboardPath} replace />;
  }

  return <>{children}</>;
};
